import * as React from 'react';
import { SegmentFilters, SegmentFiltersAdmin } from '../../../models/segments';
import { segmentsFilterReducer } from './segments-filter-reducer';

export function useSegmentFilters(
  setActiveFilters: (filters: SegmentFilters | SegmentFiltersAdmin) => void,
  defaultActiveFilters: SegmentFilters | SegmentFiltersAdmin
) {
  const [state, dispatch] = React.useReducer(segmentsFilterReducer, {
    filters: defaultActiveFilters,
    previousFilters: defaultActiveFilters,
    filterCount: 0
  });

  function handleApply() {
    setActiveFilters(state.filters);
    dispatch({ type: 'apply' });
  }

  function handleClearAll() {
    setActiveFilters(defaultActiveFilters);
    dispatch({ type: 'clearAll', defaultFilters: defaultActiveFilters });
  }

  return {
    state,
    dispatch,
    handleApply,
    handleClearAll
  };
}
